import { AlertTriangle } from "lucide-react";

export function SafetyNotice({ warnings = [], title = "Safety notice" }) {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div
      data-testid="safety-notice"
      className="my-8 rounded-xl border border-brand-clay/30 bg-brand-clay/5 p-5"
    >
      <div className="flex items-center gap-2 text-brand-clay">
        <AlertTriangle className="h-5 w-5" strokeWidth={2} />
        <span className="font-semibold">{title}</span>
      </div>
      <ul className="mt-3 space-y-1.5 text-sm text-brand-ink/80">
        {warnings.map((w, i) => (
          <li key={i} className="flex gap-2">
            <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-clay" />
            {w}
          </li>
        ))}
      </ul>
    </div>
  );
}
